// extracted by mini-css-extract-plugin
export default {"display":"firsttop_display__DPh-0","black":"firsttop_black__ZPnpj"};